import React, { useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import AppSearchInput from "components/ui/AppSearchInput";
import AppButton from "components/ui/AppButton";
import AppPaginatedTable from "components/ui/AppPaginatedTable";
import AppIcon from "components/ui/AppIcon"
const ModifierGroupList = ({ groups, deleteModifierGroup }) => {
  const router = useHistory();
  const currentPage = router?.location?.state?.activePage ?? 1;
  const recordsPerPage = router?.location?.state?.pageSize ?? 10;
  const { t } = useTranslation();

  const updateM = (rowData) => {
    router.push({
      pathname: "/app/dashboard/update-modifier-group",
      state: {
        modifier: rowData,
      },
    });
  };

  const renderActions = (value, rowData, index) => {
    return (
      <div className="flex gap-4 px-3 py-2 whitespace-nowrap text-center ">
          <span className="cursor-pointer" onClick={() => updateM(rowData)}>
            <AppIcon name="eye"></AppIcon>
          </span>
          <span className="cursor-pointer" onClick={() => deleteModifierGroup(rowData)}>
            <AppIcon name="trash"></AppIcon>
          </span>
        </div>
    );
  };

  const columns = [
    {
      title: t("Name"),
      dataIndex: "baseLanguage",
      align: "initial",
      render: (value, rowData, index) => {
        return (
          <h3 className="text-16px font-bold truncate-line-4 min-230">
            {value?.name}
          </h3>
        );
      },
    },
    {
      title: t("Selection Type"),
      dataIndex: "isSingleSelection",
      align: "initial",
      render: (value, rowData, index) => {
        return value ? t("Single") : t("Multiple");
      },
    },
    {
      title: t("Max Allowed Options"),
      dataIndex: "maximumAllowedSelection",
      align: "initial",
    },
    {
      title: t("Required"),
      dataIndex: "isRequired",
      align: "initial",
      render: (value, rowData, index) => {
        return value ? t("Yes") : t("No");
      },
    },
    {
      title: t("Actions"),
      dataIndex: "actions",
      align: "initial",
      fixed: "right",
      render: renderActions,
    },
  ];

  const createModifier = () => {
    router.push({
      pathname: "/app/dashboard/create-modifier-group",
    });
  };

  const [searchTerm, setSearch] = useState(null);

  const FilteredData = useMemo(() => {
    let searchTermLower = searchTerm?.toLowerCase()?.trim();
    if (searchTerm === "" || searchTerm === null) {
      return groups;
    }
    return groups?.filter((group) =>
      group?.baseLanguage?.name?.toLowerCase()?.includes(searchTermLower)
    );
  }, [groups, searchTerm]);

  const totalPages = Math.max(1, Math.ceil((FilteredData?.length || 0) / recordsPerPage));
  const effectivePage = Math.min(Math.max(currentPage, 1), totalPages);

  const handleSearch = (value) => {
    router.push(router.location.pathname, {
      ...router?.location?.state,
      pageSize: recordsPerPage,
      activePage: 1,
    });
    setSearch(value?.toLowerCase() ?? "");
  };

  const onPaginationChange = (newPage, newPageSize) => {
    const nextPageSize = newPageSize ?? recordsPerPage;
    const updates = {};
    if (recordsPerPage !== nextPageSize) {
      updates.pageSize = nextPageSize;
    }
    if (currentPage !== newPage) {
      updates.activePage = newPage;
    }
    if (Object.keys(updates).length > 0) {
      router.push(router.location.pathname, {
        ...router?.location?.state,
        ...updates,
      });
    }
  };

  return (
    <div className="my-2 flex min-h-0 flex-1 flex-col gap-4">
        <div className="flex gap-4 flex-col md:flex-row md:justify-end justify-center md:items-center">
          <div className="sm:mt-0">
            <AppSearchInput
              placeholder={t("Search by name")}
              value={searchTerm ?? ""}
              onInput={(event) => handleSearch(event.target.value)}
            />
          </div>
          <AppButton onClick={() => createModifier()}>
              {t("Create Modifier Group")}
            </AppButton>
        </div>
      <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
        <AppPaginatedTable
          columns={columns}
          data={FilteredData}
          clientSidePagination
          page={effectivePage}
          pageSize={recordsPerPage}
          onPageChange={onPaginationChange}
          rowOptions={[10, 20, 50, 100]}
        />
      </div>
    </div>
  );
};
export default ModifierGroupList;
ModifierGroupList.propTypes = {
  item: PropTypes.object,
};
